import { render, staticRenderFns } from "./LiveChip.vue?vue&type=template&id=0af016c2&scoped=true"
import script from "./LiveChip.vue?vue&type=script&lang=ts"
export * from "./LiveChip.vue?vue&type=script&lang=ts"
import style0 from "./LiveChip.vue?vue&type=style&index=0&id=0af016c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af016c2",
  null
  
)

export default component.exports